import { DateSelectionT } from "@components/atoms/EventDate"

export function dateSorter(dates: DateSelectionT[]) {
  const today = new Date()
  const filtered = dates?.filter((item) => {
    if (!item?.date) return
    const [day, month, year] = item.date.split("/").map(Number)
    const d = new Date(year, month - 1, day)
    return d.getTime() >= today.getTime() - 24 * 60 * 60 * 1000
  })

  return filtered
}
